export enum IdentificationAnalyticsEnum {
  VIEW_EMAIL_SCREEN = '[PAC WEB] Identificação - Viu tela de e-mail',
  EMAIL_INFORMED = '[PAC WEB] Identificação - Informou e-mail',
  EMAIL_ERROR = '[PAC WEB] Identificação - Erro no e-mail',
}

export enum IdentificationOrigin {
  SLOT = 'slot',
}

export enum EmailErrorReason {
  INVALID_FORMAT = 'formato_invalido',
}
